
            export const contractAddress = "0x917d4281AFAfb9d8965707A3EFa398dd4Be66dc6"
            export const ownerAddress = "0x32e23c6ee71d759f65E531aF513D6C938c15C1E4"
            export const networkDeployedTo = "1"
        